import script from "./AppSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSpinner.vue?vue&type=script&setup=true&lang=js"

import "./AppSpinner.vue?vue&type=style&index=0&id=79312e7c&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79312e7c"]])

export default __exports__